
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "LOREM, IPSUM DOLOR",
    },
    slogan: {
      type: String,
      default: null,
    },
    backgroundImage: {
      type: String,
      default: null,
    },
  },
  data: () => ({}),
});
